import { NestedObjectsPathKeys } from '../utils';

export enum SortOptions {
  ASC = 'asc',
  DESC = 'desc',
}

export type Sorting<
  T extends object,
  Type extends SortOptions,
  K extends string = NestedObjectsPathKeys<Required<T>>,
> = `${K}:${Type}`;
